import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation } from '@tanstack/react-query';
import { getErrorCode, getErrorStatusCode } from "../../../../api/api-response";
import { RestEndpoints } from "../../../../api/endpoints";
import { ICfmProductPackageConfig } from "../../../../configurator/components/package/create-product-package-config-content.component";
import getInstance from "../../../../utils/rest";
import { CfmCreateProductPackageConfigConverter } from "../../models/converter/cfm-create-product-package-config.converter";

const createProductPackageConfig = async (config: ICfmProductPackageConfig[]): Promise<void> => {
  const convertedConfig = config.map(CfmCreateProductPackageConfigConverter.dataToModel);
  await getInstance().post(RestEndpoints.CreateProductPackageConfigs, { data: convertedConfig });
};

export const useCreateProductPackageConfig = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: ({ config }: { config: ICfmProductPackageConfig[] }) => createProductPackageConfig(config),

    onError: (error) => {
      const errorMsg = getErrorCode(error);
      const errorCode = getErrorStatusCode(error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    },
  });
};
